<template>
  <!-- Client Connect -->
  <detail-item
    icon="mdi-shield-link-variant-outline"
    name="Client Connect"
    help-filter="client connect"
    :with-input="client.linked ? 30 : undefined"
  >
    <div
      v-if="client.linked"
      class="flex q-gutter-sm"
    >
      <q-chip
        icon="mdi-link-variant"
        square
      >
        Linked through Client Connect
      </q-chip>
    </div>
    <!-- Send signup request to client -->
    <div
      v-else-if="!client.linked && client.refer_status === 'PENDING' && client.refer_resend_tries < 3 && client.email_address && can(permissions.canAccessClients) && !isArchived"
    >
      <q-item-label>
        <template v-if="client.refer_resend_tries > 0">
          A request was sent but hasn't been accepted yet — you can resend it.
        </template>
        <template v-else>
          Invite this client to link their account and access their quotations, invoices and reports<span v-if="!!client.email_address"> — sent to <b>{{ client.email_address }}</b></span>.
        </template>
      </q-item-label>
      <q-item-label
        v-if="client.refer_code"
        caption
        class="text-grey-7 q-mt-xs"
      >
        Or share connect code <b>{{ client.refer_code }}</b>
      </q-item-label>
      <q-btn
        :label="client.refer_resend_tries > 0 ? 'Resend Signup Request' : 'Send Signup Request'"
        class="full-width q-mt-sm"
        align="left"
        icon="mdi-email-arrow-right-outline"
        no-caps
        color="blue-7"
        @click="resendReferEmail"
      />
    </div>
    <div
      v-else-if="!client.linked"
      class="text-grey-7"
    >
      <div v-if="!client.email_address && !isArchived && can(permissions.canAccessClients)">
        <div>There is no email address attached to this client.</div>
        <div class="q-mb-sm">
          Add an email to this client to send a Client Connect request.
        </div>
      </div>
      <div v-else>
        No details to display
      </div>
    </div>
  </detail-item>
</template>

<script>
export default {
  props: {
    client: {
      type: Object,
      required: true
    },
    isArchived: {
      type: Boolean,
      default: false
    }
  },
  emits: ['reload'],
  methods: {
    /* Resend referral email */
    async resendReferEmail () {
      this.$loading.show()
      const { status } = await this.$post('v1/refer/email/resend', {
        client_id: this.client.id
      })
      this.$loading.hide()
      if (status === 'success') {
        this.client.refer_resend_tries++
        this.$q.dialog({
          title: 'Sent',
          message: 'An email has been sent to this client. You may resend this email ' + (3 - this.client.refer_resend_tries) + ' more times.'
        })
        this.$emit('reload')
      }
    }
  }
}
</script>
